<script>
  // # # # # # # # # # # # # # # # # #
  //
  //  MALWAREBOX
  //
  // # # # # # # # # # # # # # # # # #

  // *** IMPORT
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import { scale, fade } from "svelte/transition";

  const dispatch = createEventDispatcher();

  const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  // PROPS
  export let text = "";
  export let top = getRandomInt(20, window.innerHeight - 400);
  export let left = getRandomInt(20, window.innerWidth - 400);

  const allow = () => {
    dispatch("reduceCounter");
  };

  const deny = () => {
    dispatch("reduceCounter");
  };
</script>

<style lang="scss">
  @import "../variables.scss";

  .malware-box {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) scaleY(1.2);
    font-family: "Akzidenz-Grotesk BQ", helvetica, arial, sans-serif;
    font-weight: bold;
    z-index: 1000;
    border: 0;
    text-transform: uppercase;
    background: white;
    display: block;
    position: fixed;
    width: 500px;
    max-width: 90vw;
    z-index: 10000;
    padding: 10px;
    text-align: left;
    user-select: none;
    color: black;
    font-size: 42px;
    line-height: 0.9em;
    font-weight: normal;
    opacity: 1;
    border: 5px solid black;
    cursor: pointer;
    text-align: center;

    @include screen-size("small") {
      font-size: 32px;
    }
  }
</style>

<!-- in:fade={{ duration: 500, delay: 200 }}
  out:fade={{ duration: 300 }} -->
<div class="malware-box" on:click={allow}>
  <div class="text">
    {@html text}
  </div>
</div>
